import React from 'react';
import { object } from 'prop-types';
import { trackQuickSignupStep2 } from '@/utils/analytics';

import { Form } from 'antd';
import { Button, IconChevronLeft, IconChevronRight } from '@seekube-tech/ui-kit';

import '@/components/ModalBig/styles.less';
import {
  FooterNav
} from '@/scenes/Event/scenes/Candidate/scenes/Preparation/scenes/Onboarding/components/FooterNav/FooterNav';
import Wrapper from '@/components/Wrapper';
import { useFormatMessage } from 'react-intl-hooks';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { toJS } from '@/utils';
import { DiscoveryList } from '@/scenes/Auth/scenes/CandidateScenes/Discovery/DiscoveryList';
import { patchUserBeforeSignUp } from '@/store/user/actions';
import { postPreregistrationBatch } from '@/store/participant/actions';
import { useDispatch } from 'react-redux';

const Discovery = ({
  authUser,
  form
}) => {
  if (!authUser) return null;

  const t = useFormatMessage();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const { targets, countTotalJD } = form.getFieldValue('trackersData')
    const eventIds = form.getFieldValue('eventIds');
    const userId = authUser._id;

    trackQuickSignupStep2({ user: authUser, targets, countSelectedJD: targets.length, countTotalJD });

    dispatch(patchUserBeforeSignUp({
      userId,
      userParams: { isActive: true },
      callback: () => postPreregistration(eventIds),
    }));
  };

  const postPreregistration = (eventIds) => {
    const userId = authUser._id;

    dispatch(postPreregistrationBatch({
      eventIds,
      userId,
      callback: () => {
        history.push('/events')
      },
    }))
  }


  return (
    <Wrapper size="large">
      <Form onSubmit={handleOnSubmit}>
        <DiscoveryList form={form} />

        <FooterNav>
          <Button
            onClick={() => history.push('profile')}
            imageComponentLeft={<IconChevronLeft size={16}  />}
            color="neutral"
            variant="outline"
          >
            {t({ id: 'previous.step' })}
          </Button>
          <Button type="submit" imageComponentRight={<IconChevronRight size={16} />}>
            {t({ id: 'complete.my.registration' })}
          </Button>
        </FooterNav>
      </Form>
    </Wrapper>
  );
}

Discovery.propTypes = {
  authUser: object,
  form: object,
};

const withForm = Form.create();

export default compose(
  withForm,
)(toJS(Discovery));
